import BigImg from '../../components/BigImg.vue';
import { Toast, Dialog } from 'vant';


export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },
    components: {
        BigImg,
    },
    data() {
        return {
            photoVisible: false,
            bigImgUrl: "",

            status: 0,
            timer: null,
            restTime: null, //剩余时间
            remainTime: null,
            currentTime: null, //当前时间
            memberPhone: '', //提交的phone
            detailDatas: {} //详情对象
        };
    },

    mounted() {
        if (this.$route.query.memberId != undefined) {
            this.getMemberById();
            this.getCouponDetail();
        }

    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },
    methods: {
        // 倒计时
        countTime() {
            //毫秒数或使用结束时间减去当前时间得到
            let remainTime = this.remainTime;
            let h, m, s, d, ms;
            if (remainTime >= 0) {
                d = Math.floor(remainTime / 1000 / 60 / 60 / 24); //天
                h = Math.floor((remainTime / 1000 / 60 / 60) % 24); //时
                m = Math.floor((remainTime / 1000 / 60) % 60); //分
                s = Math.floor((remainTime / 1000) % 60); //秒
                ms = String(Math.floor(remainTime % 1000)).substring(0, 1); //毫秒只保留前一位

                //补足两位数
                s = s < 10 ? "0" + s : s;
                m = m < 10 ? "0" + m : m;
                h = h < 10 ? "0" + h : h;
            } else {
                //小于0清除定时器重置数据
                h = m = s = d = "00";
                ms = 0;
                clearInterval(this.timer);
            }
            this.timeData = {
                day: d,
                hours: h,
                minutes: m,
                seconds: s,
                millisecond: ms,
            };
            this.remainTime = this.remainTime - 30;
            // console.log(this.remainTime, " this.remainTime");
            if (this.remainTime < 0) {
                clearInterval(this.timer);
                this.detailDatas.dhStatus = 1;
            }
            // console.log(this.remainTime, " this.remainTime");
        },

        // 根据会员ID获取会员对象 API
        getMemberById: function() {
            this.$api.getMemberById({
                params: {
                    'memberId': this.$route.query.memberId + '',
                },
                success: function(res) {
                    console.log(res.data, "res.data手机号");
                    this.memberPhone = res.data.phone;


                }.bind(this),
                fail: function(res) {
                    console.log(":::fail", res)

                }
            })
        },
        // 消费券抢购商品详情 API
        getCouponDetail: function() {
            // console.log(this.currentTime);
            this.$api.getCouponDetail({
                params: {
                    'couponId': this.$route.query.couponId + '',
                    'memberId': this.$route.query.memberId + '',
                },
               
                success: function(res) {
                    // console.log(res.data, "res.data777");
                    this.detailDatas = res.data;
                    // 抢购状态 0： 即将开始 1： 抢购中 2： 已抢完 3： 会员已抢购 4： 不可重复抢购
                    if (res.data.dhStatus == 0) {
                        this.getCouponRestTime();
                    }

                }.bind(this),
                fail: function(res) {
                    console.log(":::fail", res)

                }
            })
        },
        // 消费券剩余时间获取 API
        getCouponRestTime: function() {
            this.$api.getCouponRestTime({
                params: {
                    'couponId': this.$route.query.couponId + '',
                },
                success: function(res) {
                    // console.log(res.data, "res.data");
                    this.remainTime = res.data; //剩余时间（ms）
                    // console.log(this.remainTime, " this.remainTime ");
                    // 定时任务  后台获取秒倒计时
                    // 剩余时间，若大于0则开启倒计时
                    if (this.remainTime > 0) {
                        this.timer = setInterval(() => {
                            this.countTime();
                        }, 30);
                    }



                }.bind(this),
                fail: function(res) {
                    console.log(":::fail", res)

                }
            })
        },
        // 抢购（秒杀）优惠券 API
        getCouponKill: function() {
            this.$api.getCouponKill({
                params: {
                    'couponId': this.$route.query.couponId + '',
                    'memberId': this.$route.query.memberId + '',
                    'memberPhone': this.memberPhone,
                },
                success: function(res) {
                    if (res.code == 0) {
                        Dialog({
                            title: '抢券成功',
                            message: ' 稍后您可在抢券主页右上角“兑换记录”中出示兑换码，凭借兑换码核销',
                            theme: 'round-button',
                        }).then(() => {
                            // on close
                            location.reload();
                        });

                    } else {
                        Dialog({
                            message: res.msg,
                            theme: 'round-button',
                        }).then(() => {
                            // on close
                            location.reload();
                        });
                    }



                }.bind(this),
                fail: function(res) {
                    console.log(":::fail", res)
                    Toast.success(res.msg);

                }
            })
        },

        showBigImage(e) { //点击图片函数，点击后，把photoVisible设置成true

                this.photoVisible = true;
                this.bigImgUrl = e.currentTarget.src;

        },

    }
};